import { logError } from '../clientLogging';
import { getConfig } from '../config/configuration';
import { fetchResolver } from '../engineClient/actions/fetchResolver';
import { getMetaDataOrUndefinedFromAnswers } from '../engineClient/tools/clientAndServerUtilities';
import { getAnswersIdCookie } from '../engineClient/tools/cookieUtilities';
import { isAgent } from '../engineClient/tools/utilities';
import {
  HpClientAnswerMap,
  HpCreateActionPromisesProps,
  HpDependentActionFunction,
  HpDispatchFunction
} from '../engineClient/types';
import { getOriginSite } from '../handlers/handlerUtilities';
import { CustomerDetails } from '../types/policyTypes';
import { questionIds } from '../types/questionConstants';

const { artemisPasWeb, customerPortalPassbackUrl } = getConfig();

export interface HpTransferToCustomerPortalPayload {
  answers: HpClientAnswerMap;
}

export function transferToCustomerPortalDependentAction(
  properties: HpCreateActionPromisesProps
): HpDependentActionFunction<unknown> | undefined {
  const { questionSet } = properties;
  return transferToCustomerPortalAction({ answers: questionSet.answers }) as HpDependentActionFunction<unknown>;
}

export function transferToCustomerPortalAction(
  props: HpTransferToCustomerPortalPayload
): (dispatch: HpDispatchFunction<HpTransferToCustomerPortalPayload>) => Promise<boolean> {
  return (dispatch: HpDispatchFunction<HpTransferToCustomerPortalPayload>): Promise<boolean> => {
    return new Promise<boolean>((resolve, reject) => {
      const { answers } = props;
      const customerDetailsJson = answers[questionIds.customerDetails].customer as string;
      const customerDetails: CustomerDetails = JSON.parse(customerDetailsJson);
      const { productIdDefault } = getConfig();
      if (isAgent(getMetaDataOrUndefinedFromAnswers(productIdDefault, answers))) {
        const origin = getOriginSite();

        if (origin && origin === 'customerportal') {
          const url = `${customerPortalPassbackUrl}?emailAddress=${customerDetails.emailAddress}&postcode=${customerDetails.postcode}`;
          location.href = url;
        } else {
          const url = artemisPasWeb;
          location.href = url;
        }

        return resolve(true);
      }

      fetchResolver<unknown, any>({
        options: {
          url: `/api/passback`,
          data: { answersId: getAnswersIdCookie() },
          method: 'POST',
          description: `Transfer back to customer portal action`
        },
        dispatch,
        loadingPageType: 'page',
        successAction: (resp) => {
          const { customerPortalPassbackUrl } = getConfig();
          const { key } = resp;
          const url = `${customerPortalPassbackUrl}passback/${key}`;
          location.href = url;
        },
        failedAction: (reason) => {
          const messageToLog = `Failed to transfer to customer portal failed.\n\n${
            reason === 'string' ? reason : JSON.stringify(reason, null, 2)
          }`;
          logError(messageToLog);
        }
      })
        .then(() => resolve(true))
        .catch(reject);
    });
  };
}
